import React, { createContext, useContext, useState, useEffect } from 'react';

const SpeechBubbleContext = createContext();

export const useSpeechBubble = () => {
  const context = useContext(SpeechBubbleContext);
  if (!context) {
    throw new Error('useSpeechBubble must be used within a SpeechBubbleProvider');
  }
  return context;
};

export const SpeechBubbleProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true); // Default to open

  // Load preference from localStorage on mount
  useEffect(() => {
    const savedPreference = localStorage.getItem('speechBubblePreference');
    if (savedPreference !== null) {
      setIsOpen(JSON.parse(savedPreference));
    }
  }, []);

  // Save preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('speechBubblePreference', JSON.stringify(isOpen));
  }, [isOpen]);

  const toggleSpeechBubbles = () => {
    setIsOpen(prevState => !prevState);
  };

  return (
    <SpeechBubbleContext.Provider value={{ isOpen, toggleSpeechBubbles }}>
      {children}
    </SpeechBubbleContext.Provider>
  );
}; 